import { useEffect, useMemo, useState } from 'react';
import { GetTaskLevelLabel } from 'utils/strings';

interface PointItemProps {
  data: any;
}
export function RedePoint({ data }: PointItemProps) {
  const [origin, setOrigin] = useState<any>();
  const [taskOpened, setTaskOpened] = useState(false);

  useEffect(() => {
    const defaultPoint = {
      type: 'default',
      title: 'Crédito de Pontos',
      total: data.totalMissao,
      time: data.time,
    };

    try {
      if (data?.log && data?.log.length) {
        const log = data?.log[0];
        setOrigin({
          type: data.extra.type,
          extra: data.extra,
          log,
          total: data.totalMissao,
          time: data.time,
        });
      } else if (data.type) {
        setOrigin(data);
      } else {
        setOrigin(defaultPoint);
      }
    } catch (e) {
      setOrigin(defaultPoint);
    }
  }, [data]);

  function translateTitle(title: string, time: number) {
    if (time >= 1730084400000) {
      const _title = title.replace(/Nível \d+ - /, '');
      return _title;
    }

    return title;
  }

  return useMemo(() => {
    function renderValoracaoGestor() {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center">
              <div className="flex-1 text-lg leading-none">
                <p className="font-normal text-sm" tabIndex={0}>
                  Validação da Realização Destaque - {translateTitle(origin.faseTitle, origin.time)}{' '}
                </p>
                {origin.task ? (
                  <p className="font-thin text-sm mt-1" tabIndex={0}>
                    {origin.task.title}{' '}
                    <button
                      className="font-thin underline hover:no-underline text-electric-blue"
                      onClick={() => setTaskOpened(prevstate => !prevstate)}
                    >
                      {!taskOpened ? 'mais' : 'menos'}
                    </button>
                  </p>
                ) : null}
              </div>

              <div
                className="flex-1 text-lg leading-none"
                tabIndex={0}
                aria-label={`Status: ${GetTaskLevelLabel(origin.task.status)}`}
              >
                <p className="font-thin text-sm">Status</p>
                <p className="font-normal text-sm mt-1">{GetTaskLevelLabel(origin.task.status)}</p>
              </div>

              {origin.nome_uor && (
                <div
                  className="flex-1 text-lg leading-none"
                  tabIndex={0}
                  aria-label={`Grupo de trabalho: ${GetTaskLevelLabel(origin.nome_uor)}`}
                >
                  <p className="font-thin text-sm">Grupo de trabalho</p>
                  <p className="font-normal text-sm mt-1">{GetTaskLevelLabel(origin.nome_uor)}</p>
                </div>
              )}
              <div
                className="text-base leading-none"
                tabIndex={0}
                aria-label={`${origin.totalMissao ? Intl.NumberFormat('pt-BR').format(Math.ceil(origin.totalMissao)) : '0'} pontos`}
              >
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {origin.totalMissao ? Intl.NumberFormat('pt-BR').format(Math.ceil(origin.totalMissao)) : '0'}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>

            {taskOpened && typeof origin.task.description === 'string' ? (
              <div>
                <p className="font-normal text-sm text-white" tabIndex={0}>
                  Detalhes da realização:
                </p>
                <p
                  tabIndex={0}
                  className="font-thin text-sm text-white m-1"
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.task.description === 'string'
                        ? origin.task.description.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            ) : null}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderValoracaoGestorFeedback() {
      try {
        return (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-0 md:space-x-3 rounded-xl">
            <div className="flex-1 flex flex-row space-x-3 items-center">
              <div className="flex-1 text-lg leading-none">
                <p className="font-normal text-sm" tabIndex={0}>
                  Feedback enviado nas Realizações Destaque avaliadas - {origin.cicloTitle} - {origin.faseTitle}{' '}
                </p>
              </div>

              <div
                className="text-base leading-none"
                tabIndex={0}
                aria-label={`${origin.totalMissao ? Intl.NumberFormat('pt-BR').format(Math.ceil(origin.totalMissao)) : '0'} pontos`}
              >
                {/* <p className="font-thin text-xs mb-2 uppercase"></p> */}
                <b className="flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
                  {origin.totalMissao ? Intl.NumberFormat('pt-BR').format(Math.ceil(origin.totalMissao)) : '0'}
                  <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                </b>
              </div>
            </div>
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderEntregaEquipe() {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-3 md:items-center">
              {/* <div>
              {origin.status === 'aprovado' ? <RiThumbUpLine size={24} className="text-yellow" /> : null}
              {origin.status === 'dobrado' ? <BiCoinStack size={24} className="text-yellow" /> : null}
              {origin.status === 'promovido' ? <BiUpvote size={24} className="text-yellow" /> : null}
              {origin.status === 'selo' ? <BiTrophy size={24} className="text-yellow" /> : null}
            </div> */}
              {/* <div className="flex-1">
              <b>{origin.titulo}</b>
            </div> */}

              <div className="flex-1 text-lg leading-none" tabIndex={0}>
                <p className="font-thin text-sm">Nome da realização</p>
                <p className="font-normal text-sm mt-1">
                  {origin.titulo} - {translateTitle(origin.faseTitle, origin.time)}{' '}
                  <button
                    className="font-thin underline hover:no-underline text-electric-blue"
                    onClick={() => setTaskOpened(prevstate => !prevstate)}
                  >
                    {!taskOpened ? 'mais' : 'menos'}
                  </button>
                </p>
              </div>

              <div className="flex-1 text-lg leading-none" tabIndex={0} aria-label={`Status:  ${origin.status}`}>
                <p className="font-thin text-sm">Status</p>
                <p className="font-normal text-sm mt-1">{GetTaskLevelLabel(origin.status)}</p>
              </div>

              {origin.nome_uor && (
                <div className="flex-1 text-lg leading-none" tabIndex={0} aria-label={`Grupo de trabalho: ${origin.nome_uor}`}>
                  <p className="font-thin text-sm">Grupo de trabalho</p>
                  <p className="font-normal text-sm mt-1">{GetTaskLevelLabel(origin.nome_uor)}</p>
                </div>
              )}

              <div className="text-base leading-none">
                {origin?.totalMissao ? (
                  <b
                    className="inline-flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none"
                    tabIndex={0}
                    aria-label={`${origin.totalMissao ? Intl.NumberFormat('pt-BR').format(Math.ceil(origin.totalMissao)) : '0'} pontos`}
                  >
                    {origin.totalMissao ? Intl.NumberFormat('pt-BR').format(Math.ceil(origin.totalMissao)) : '0'}
                    <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                  </b>
                ) : null}
              </div>
            </div>

            {taskOpened && typeof origin.descricao === 'string' ? (
              <div>
                <p className="font-normal text-sm text-white" tabIndex={0}>
                  Detalhes da realização:
                </p>
                <p
                  className="font-thin text-sm text-white m-1"
                  tabIndex={0}
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.descricao === 'string'
                        ? origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            ) : null}
            {/* <div className="flex flex-row space-x-3 items-center justify-center">
            <div className="flex flex-row items-center space-x-2 px-2 text-white py-1 bg-purple rounded-full">
              <b>Participação: {origin.participacao}%</b>
            </div>
            <div className="flex flex-row items-center space-x-2 px-2 text-blue-dark py-1 bg-yellow rounded-full">
              <b>+{origin.total} pontos</b>
            </div>
          </div> */}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    function renderEntregaUnidade() {
      try {
        return (
          <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
            <div className="flex-1 flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-3 md:items-center">
              {/* <div>
              {origin.status === 'aprovado' ? <RiThumbUpLine size={24} className="text-yellow" /> : null}
              {origin.status === 'dobrado' ? <BiCoinStack size={24} className="text-yellow" /> : null}
              {origin.status === 'promovido' ? <BiUpvote size={24} className="text-yellow" /> : null}
              {origin.status === 'selo' ? <BiTrophy size={24} className="text-yellow" /> : null}
            </div> */}
              {/* <div className="flex-1">
              <b>{origin.titulo}</b>
            </div> */}

              <div className="flex-1 text-lg leading-none" tabIndex={0}>
                <p className="font-thin text-sm">Nome da realização</p>
                <p className="font-normal text-sm mt-1">
                  {origin.titulo} - {origin.faseTitle}{' '}
                  <button
                    className="font-thin underline hover:no-underline text-electric-blue"
                    onClick={() => setTaskOpened(prevstate => !prevstate)}
                  >
                    {!taskOpened ? 'mais' : 'menos'}
                  </button>
                </p>
              </div>

              <div className="flex-1 text-lg leading-none" tabIndex={0} aria-label={`Status:  ${origin.status}`}>
                <p className="font-thin text-sm">Status</p>
                <p className="font-normal text-sm mt-1">{GetTaskLevelLabel(origin.status)}</p>
              </div>

              <div className="flex-1 text-lg leading-none" tabIndex={0} aria-label={`Grupo de trabalho: ${origin.nome_uor}`}>
                <p className="font-thin text-sm">Grupo de trabalho</p>
                <p className="font-normal text-sm mt-1">{GetTaskLevelLabel(origin.nome_uor)}</p>
              </div>

              <div className="text-base leading-none">
                {origin?.totalMissao ? (
                  <b
                    className="inline-flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none"
                    tabIndex={0}
                    aria-label={`${origin.totalMissao ? Intl.NumberFormat('pt-BR').format(Math.ceil(origin.totalMissao)) : '0'} pontos`}
                  >
                    {origin.totalMissao ? Intl.NumberFormat('pt-BR').format(Math.ceil(origin.totalMissao)) : '0'}
                    <span className="block font-thin text-[10px] mt-1 uppercase leading-none">Pontos</span>
                  </b>
                ) : null}
              </div>
            </div>

            {taskOpened && typeof origin.descricao === 'string' ? (
              <div>
                <p className="font-normal text-sm text-white" tabIndex={0}>
                  Detalhes da realização:
                </p>
                <p
                  className="font-thin text-sm text-white m-1"
                  tabIndex={0}
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof origin.descricao === 'string'
                        ? origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
                        : '',
                  }}
                />
              </div>
            ) : null}
            {/* <div className="flex flex-row space-x-3 items-center justify-center">
            <div className="flex flex-row items-center space-x-2 px-2 text-white py-1 bg-purple rounded-full">
              <b>Participação: {origin.participacao}%</b>
            </div>
            <div className="flex flex-row items-center space-x-2 px-2 text-blue-dark py-1 bg-yellow rounded-full">
              <b>+{origin.total} pontos</b>
            </div>
          </div> */}
          </div>
        );
      } catch (e) {
        return null;
      }
    }

    if (!origin) return null;

    switch (origin.type) {
      case 'entrega_equipe':
        return renderEntregaEquipe();
      case 'entrega_gestor':
        return renderValoracaoGestor();
      case 'feedback_gestor':
        return renderValoracaoGestorFeedback();
      case 'entrega_unidade':
        return renderEntregaUnidade();
      default:
        return (
          <>
            <p>bolo</p>
          </>
        );
    }
  }, [origin, taskOpened]);
}
